<template>
  <button type="button" class="orders-entry" :disabled="disabled" @click="$emit('open')">Мої замовлення</button>
</template>
<script>
export default { props: { disabled: { type: Boolean, default: false } } };
</script>
<style scoped>
.orders-entry { display: block; margin: 8px 16px 16px; padding: 12px 16px; min-height: 44px; color: #155d9b; background: #fff; border: 1px solid #b4cde3; border-radius: 8px; cursor: pointer; font: inherit; }
.orders-entry:focus-visible { outline: 2px solid #155d9b; outline-offset: 2px; }
.orders-entry:disabled { opacity: .6; cursor: wait; }
</style>
